/**
 * Variant Info Component
 * Displays dynamic messages based on the selected product variant
 */

if (!customElements.get('variant-info')) {
  class VariantInfo extends HTMLElement {
    static get observedAttributes() {
      return ['data-show-all'];
    }

    constructor() {
      super();
      this.messages = {};
      this.optionName = this.dataset.optionName;

      try {
        this.messages = JSON.parse(this.dataset.messages);
      } catch (e) {
        // silent
      }

      this.messageElements = this.querySelectorAll('.variant-info__message');
      this.productData = null;
    }

    connectedCallback() {
      this.loadProductData();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data && event.data.variant) {
            this.updateForVariant(event.data.variant);
          }
        });
      }

      document.addEventListener('change', (event) => {
        if (event.target.closest('variant-selects') || event.target.closest('variant-radios') ||
            event.target.matches('.product-form__input input[type="radio"]') ||
            event.target.matches('.product-form__input select')) {
          setTimeout(() => this.update(), 150);
        }
      });

      setTimeout(() => this.update(), 100);
      setTimeout(() => this.update(), 500);
      setTimeout(() => this.update(), 1500);
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-show-all') {
        if (newValue !== null) {
          this.showAllMessages();
        } else {
          this.update();
        }
      }
    }

    showAllMessages() {
      this.messageElements.forEach(function(el) {
        el.style.display = 'block';
      });
    }

    loadProductData() {
      var productJsonEl = this.closest('[data-section]');
      if (productJsonEl) {
        var scriptEl = productJsonEl.querySelector('[data-product-json]') ||
                       productJsonEl.querySelector('script[data-product-json]') ||
                       productJsonEl.querySelector('[data-main-product-json]');
        if (scriptEl) {
          try {
            this.productData = JSON.parse(scriptEl.textContent);
            return;
          } catch (e) {
            // fall through
          }
        }
      }

      var globalEl = document.querySelector('[data-product-json]');
      if (globalEl) {
        try {
          this.productData = JSON.parse(globalEl.textContent);
          return;
        } catch (e) {
          // fall through
        }
      }

      var bundleJsonEl = document.querySelector('script[data-product-json]');
      if (bundleJsonEl) {
        try {
          this.productData = JSON.parse(bundleJsonEl.textContent);
        } catch (e) {
          // fall through
        }
      }
    }

    update() {
      if (this.hasAttribute('data-show-all')) {
        this.showAllMessages();
        return;
      }

      var variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        var variant = this.findVariantById(variantInput.value);
        if (variant) {
          this.updateForVariant(variant);
          return;
        }
      }

      var urlParams = new URLSearchParams(window.location.search);
      var variantId = urlParams.get('variant');
      if (variantId) {
        var variant = this.findVariantById(variantId);
        if (variant) {
          this.updateForVariant(variant);
          return;
        }
      }

      this.showMessage(this.getFirstMessage());
    }

    findVariantById(variantId) {
      var searchId = String(variantId);

      if (this.productData && this.productData.variants) {
        var found = this.productData.variants.find(function(v) {
          return String(v.id) === searchId;
        });
        if (found) return found;
      }

      var selectsEl = document.querySelector('variant-selects');
      if (selectsEl) {
        var jsonEl = selectsEl.querySelector('[data-selected-variant]');
        if (jsonEl) {
          try {
            var selected = JSON.parse(jsonEl.textContent);
            if (selected && String(selected.id) === searchId) {
              return selected;
            }
          } catch (e) {
            // fall through
          }
        }
      }

      return null;
    }

    updateForVariant(variant) {
      if (this.hasAttribute('data-show-all')) {
        this.showAllMessages();
        return;
      }

      if (!variant || !variant.options) {
        this.hideAllMessages();
        return;
      }

      var options = this.getProductOptions();
      if (!options || options.length === 0) {
        this.hideAllMessages();
        return;
      }

      var targetIndex = -1;
      var optionNameLower = this.optionName.toLowerCase().trim();

      for (var i = 0; i < options.length; i++) {
        if (options[i].toLowerCase().trim() === optionNameLower) {
          targetIndex = i;
          break;
        }
      }

      if (targetIndex === -1 || targetIndex >= variant.options.length) {
        this.hideAllMessages();
        return;
      }

      var optionValue = variant.options[targetIndex];
      this.showMessageForValue(optionValue);
    }

    getProductOptions() {
      if (this.productData && this.productData.options && this.productData.options.length > 0) {
        return this.productData.options;
      }

      var sectionEl = this.closest('[data-section]') || this.closest('product-info');
      if (sectionEl) {
        var labels = sectionEl.querySelectorAll('.product-form__input .form__label');
        var options = [];
        labels.forEach(function(el) {
          var text = el.textContent.trim().replace(/:$/, '').trim();
          if (text) options.push(text);
        });
        if (options.length > 0) return options;
      }

      var allLabels = document.querySelectorAll('.product-form__input .form__label');
      var allOptions = [];
      allLabels.forEach(function(el) {
        var text = el.textContent.trim().replace(/:$/, '').trim();
        if (text) allOptions.push(text);
      });
      return allOptions;
    }

    showMessageForValue(value) {
      if (this.hasAttribute('data-show-all')) {
        this.showAllMessages();
        return;
      }

      this.hideAllMessages();

      var valueLower = value.toLowerCase().trim();
      var matchingMessage = null;

      this.messageElements.forEach(function(el) {
        if (el.dataset.optionValue && el.dataset.optionValue.toLowerCase().trim() === valueLower) {
          matchingMessage = el;
        }
      });

      if (matchingMessage) {
        matchingMessage.style.display = 'block';
      }
    }

    showMessage(messageElement) {
      if (messageElement) {
        this.hideAllMessages();
        messageElement.style.display = 'block';
      }
    }

    getFirstMessage() {
      return this.messageElements[0] || null;
    }

    hideAllMessages() {
      this.messageElements.forEach(function(el) {
        el.style.display = 'none';
      });
    }
  }

  customElements.define('variant-info', VariantInfo);
}
